import { render, staticRenderFns } from "./SearchHistory.vue?vue&type=template&id=0460e0b1&scoped=true"
import script from "./SearchHistory.vue?vue&type=script&lang=js"
export * from "./SearchHistory.vue?vue&type=script&lang=js"
import style0 from "./SearchHistory.vue?vue&type=style&index=0&id=0460e0b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0460e0b1",
  null
  
)

export default component.exports